import React from 'react'

const SeparatedDot = ({
  className = 'pr-1',
  ...props
}) => (
  <span className={className}>•</span>
)
export default SeparatedDot
